<template>
    <v-card flat tile color="white" class="h-100 pa-16px black--text">
        <v-row no-gutters justify="center" align="center">
            <v-col cols="12">
                <v-img
                    max-width="240"
                    src="/images/main/flebogrif.png"
                    class="w-60 w-md-100 mx-auto mb-14px"
                />
            </v-col>
            <v-col cols="12">
                <v-card-title class="pa-0 justify-center">
                    <u-tit-default class="font-size-12 font-size-md-24 font-size-lg-36">
                        <span class="font-weight-regular font-secondary">플래보그립</span>
                        <span class="font-size-16 font-size-md-36 font-size-lg-48">
                            &nbsp;<ICountUp
                                :startVal="startVal"
                                :endVal="endVal"
                                :duration="duration"
                                :options="options"
                                class="iCountUp"
                            />
                        </span>례 이상
                    </u-tit-default>
                </v-card-title>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import api from "@/api";
import ICountUp from "vue-countup-v2";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";

export default {
    name: "main-visual-flebogrif",
    components: {
        ICountUp,
        UTitDefault
    },
    data: () => ({
        startVal: 0,
        endVal: 0,
        duration: 2.5,
        options: {
            useEasing: true,
            useGrouping: true,
            separator: ",",
            enableScrollSpy: true
        }
    }),
    created() {
        api.v1.easyleg.mains
            .gets({ params: { code: "flebogrif" } })
            .then(({ mains }) => {
                const main = (mains || []).find(
                    item => item.code === "flebogrif"
                );
                if (main) this.endVal = Number(main.count) || 0;
            });
    }
};
</script>

<style lang="scss" scoped>
.iCountUp {
    display: inline-block;
    min-width: 0;
    text-align: left;
}
</style>
